import ListMenuItem from "@/app/components/menu/listMenuItem";
import { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import style from "@/app/components/menu/overlayMenuSystem.module.scss";

export default function AccountMenuReview({}: OverlayMenuBaseProps) {
  return (
    <div className={`${style.overlayMenuContainer} ${style.faqMenu}`}>
      <div className={style.menuListItemContainer}>
        <ListMenuItem id="review-product-menu-link" linkTo="/review/products">
          Review a Product
        </ListMenuItem>
        <ListMenuItem id="review-vendor-menu-link" linkTo="/review/vendor">
          Review a Vendor
        </ListMenuItem>
        <ListMenuItem id="free-ipad-giveaway-menu-link" linkTo="/giveaways/ratings-and-reviews">
          Free iPad Giveaway Details
        </ListMenuItem>
      </div>
    </div>
  );
}
